import { ScreenProps } from "../../App";
import { useKicktippQuery } from "./queries/useKicktippQuery";
import "./styles/Kicktipp.sass";

// Hard cap so the table never overflows the screen — the display can't scroll.
const MAX_ROWS = 14;

const KicktippGameDayTableScreen: React.FC<ScreenProps> = ({
  duration,
  christmasTime,
  isActive,
}) => {
  const data = useKicktippQuery();

  if (data.isLoading) return <div>Loading...</div>;

  if (data.isError || !data.data) return <div>Error...</div>;

  const { table } = data.data;
  const gameCodes = table[0] ? Object.keys(table[0].predictions) : [];
  const rows = table.slice(0, MAX_ROWS);
  const hiddenCount = table.length - rows.length;

  return (
    <div className="kicktippScreen gameDayScreen">
      <div className="h1">
        <h1><span>9e</span> Buli-Tipp</h1>
      </div>
      <div className="h2"><h2>Spieltag — Tipps</h2></div>
      <div className="tableFull">
        <table className="rankingTable">
          <thead>
            <tr>
              <th className="position">#</th>
              <th className="name">Name</th>
              {gameCodes.map((code) => (
                <th key={code}>{code}</th>
              ))}
              <th>Pkt.</th>
              <th>Ges.</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index} className={row.position > 0 && row.position <= 3 ? "top" : ""}>
                <td className="position">{row.position > 0 ? row.position : ""}</td>
                <td className="name">{row.name}</td>
                {gameCodes.map((code) => {
                  const pred = row.predictions[code];
                  return (
                    <td key={code} className="prediction">
                      {pred?.prediction}
                      {pred?.points > 0 && <sup className="predPoints">{pred.points}</sup>}
                    </td>
                  );
                })}
                <td className="points">{row.matchday_points}</td>
                <td className="total">{row.total_points}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {hiddenCount > 0 && (
          <div className="moreNote">+ {hiddenCount} weitere</div>
        )}
      </div>
    </div>
  );
};

export default KicktippGameDayTableScreen;
